import type { FC, ReactNode } from 'react';
import { lazy, Suspense, useEffect, useState } from 'react';

import { useInitializationSlice } from '../../store/slices/initialization/selectors';
import { useSubtitlesSlice } from '../../store/slices/subtitles/selectors';

const SubtitlesConnected = lazy(() => import('./SubtitlesConnected'));

export const SubtitlesLazyConnected: FC = (): ReactNode => {
  const isReadyToRender = useInitializationSlice.getIsReadyToRender();
  const isSubtitlesAvailable = useSubtitlesSlice.isAvailable();
  const isSubtitlesEnabled = useSubtitlesSlice.isEnabled();

  const [hasEverLoaded, setHasEverLoaded] = useState(false);
  useEffect(() => {
    if (isReadyToRender && isSubtitlesAvailable && isSubtitlesEnabled) {
      setHasEverLoaded(true);
    }
  }, [isReadyToRender, isSubtitlesAvailable, isSubtitlesEnabled]);

  if (!hasEverLoaded) {
    return null;
  }

  return (
    <Suspense fallback={<></>}>
      <SubtitlesConnected />
    </Suspense>
  );
};
